import { render, staticRenderFns } from "./sales-order-table.vue?vue&type=template&id=e2ac616c&scoped=true&"
import script from "./sales-order-table.vue?vue&type=script&lang=js&"
export * from "./sales-order-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ac616c",
  null
  
)

export default component.exports